import { Redirect } from 'react-router-dom';
import { infoToast } from '../../../utils/toaster';
import * as ROUTES from '../../../constants/routes';

import Layout from '../../layouts/default-logged-in';
import * as ReportModel from '../../../models/report';
import NoAreasPanel from '../../no-areas-panel';
import { Wrapper } from '../summary/layout';

const ReportsPage = ({ reports, fetchingReports, basePath, match }) => {
  const currentBase = basePath || (match && match.path) || ROUTES.REPORTS;
  const isMyReports = currentBase === ROUTES.MY_REPORTS;

  if ((!reports || !reports.length) && !fetchingReports) {
    // if (isMyReports) {
      // Show an informational toast and redirect user to AI Reports
      infoToast({ message: 'Please create and save your first Ask Aura report' });
      return (
        <Redirect
          to={{ pathname: ROUTES.AI_REPORTS }}
        />
      );
    // }
    // return (
    //   <Layout>
    //     <Wrapper>
    //       <NoAreasPanel message="No report to display" />
    //     </Wrapper>
    //   </Layout>
    // );
  }

  const defaultReport = reports[0];

  const targetSingle = isMyReports
    ? ROUTES.SINGLE_MY_REPORT
    : ROUTES.SINGLE_REPORT;
  return (
    <Redirect
      to={{
        pathname: targetSingle.replace(':reportId', defaultReport.id),
      }}
    />
  );
};

export default ReportsPage;
